import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

import { listParameters } from "../utils/utilsInterface";

class ListParameters extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Parameters: [],
            errorMessage: ''
        };

        this.dsd = new dsd();
    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){
   if (!isEqual(this.props, prevProps)){
       this.setup();
   }
}

loadData(filters){

    const onLoad = function(arr){
        this.setState({ Parameters: arr, renderState: 'loaded' });
        if (this.state.onLoad){ this.state.onLoad(arr.length); }
    }.bind(this);

    const onError = function(e){
        let errorMessage = e.message;
        if (e.response && e.response.data && e.response.data.message){
            errorMessage = e.response.data.message;
        }
        this.setState({ renderState: 'failed', errorMessage: errorMessage });
    }.bind(this);

    listParameters(this.dsd, filters, onLoad, onError);
}


setup(){

    let StateChange = {
        filters: {},
        columns: {},
        onLoad: null
    }

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);
    this.loadData(StateChange.filters);
        
}



    included(Parameter) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {

        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    {this.state.errorMessage || 'A problem has occurred'}
                </PD.ErrorBox>
            )
        }

        if (this.state.renderState === 'loaded') {
            let arrParameters = this.state.Parameters;
            if (isArray(arrParameters)){
                if (arrParameters.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    <PD.Th>Where</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrParameters.map(
                                    (Parameter, pos) => 
                                    {
                                        if (this.included(Parameter)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/parameter/" + Parameter._id} > {Parameter.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Parameter.where){
                                                                        return Parameter.where;
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Parameter.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListParameters_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListParameters {...props} navigation={navigation} location={location} params={params} />;
  }
